<!-- @format -->
<template>
    <div class="app-user-authorize-popup app-popup">
        <div class="description">
            <p>{{ element.description }}</p>
        </div>
        <div class="user-info-container">
            <div class="user-email">User: {{ credentials.email }}</div>
            <app-input
                v-model="credentials.password"
                label="Password"
                type="password"
                :is-valid="!error"
                :error="
                    element.errorMessage || 'The password you entered is invalid. Please try again.'
                "
            />
        </div>
        <div v-if="!actions" class="app-popup-actions inner-actions">
            <app-button class="tertiary-btn" @click="close">
                {{ element.cancelButtonLabel || 'Cancel' }}
            </app-button>
            <app-button :disabled="!credentials.password" :loading="authorizing" @click="authorize">
                {{ element.authorizeButtonLabel || 'Authorize' }}
            </app-button>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const AppInput = () => import('@/components/common/app-input.vue');

export default {
    name: 'app-user-authorize-popup',

    components: {
        'app-button': AppButton,
        'app-input': AppInput,
    },

    props: {
        element: {
            type: Object,
            required: true,
        },

        actions: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            error: false,
            authorizing: false,
            credentials: {
                email: this.element.email,
                password: this.element.password,
            },
        };
    },

    methods: {
        async authorize() {
            if (!this.element.onAuthorize) {
                throw new Error(`onAuthorize function was not found in the element object`);
            }

            this.authorizing = true;
            this.error = false;
            try {
                await this.element.onAuthorize(this.credentials.email, this.credentials.password);
                this.close();
            } catch (e) {
                this.error = true;
            } finally {
                this.authorizing = false;
            }
        },

        close() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.app-user-authorize-popup .user-email {
    font-weight: 600;
}

.app-user-authorize-popup .app-popup-actions.inner-actions {
    display: flex;
    justify-content: center;
    border-top: 2px solid var(--color-border-divider);
    margin: 40px 0 0;
}
</style>
